import { TCredential } from '@/types/credentials';

export type TCredentialSchemaSlot = {
  type: string;
  name: string;
};

export function mapCredentialsToSchemaSlots(schemaSlots: TCredentialSchemaSlot[], savedCredentials: TCredential[]): string[] | null {
  const usedReferenceIds = new Set<string>();
  const referenceIds: string[] = [];

  for (const slot of schemaSlots) {
    const matchedCredential = savedCredentials.find((c) => c.type === slot.type && c.name === slot.name && !usedReferenceIds.has(c.referenceId));
    if (!matchedCredential) {
      return null;
    }
    usedReferenceIds.add(matchedCredential.referenceId);
    referenceIds.push(matchedCredential.referenceId);
  }

  return referenceIds;
}

export function resolveSlotCredentialReferenceIds(
  schemaSlots: TCredentialSchemaSlot[],
  savedCredentials: TCredential[],
  apiCredentialIds?: string[] | null
): string[] {
  const slotCount = schemaSlots.length;

  const hasFullApiCredentialOrder = apiCredentialIds != null && apiCredentialIds.length === slotCount;
  if (hasFullApiCredentialOrder) {
    return apiCredentialIds;
  }

  const mappedBySchema = mapCredentialsToSchemaSlots(schemaSlots, savedCredentials);
  if (mappedBySchema !== null) {
    return mappedBySchema;
  }

  const savedCountMatchesSlots = savedCredentials.length === slotCount;
  if (savedCountMatchesSlots) {
    return savedCredentials.map((c) => c.referenceId);
  }

  return Array.from({ length: slotCount }, (_, index) => savedCredentials[index]?.referenceId ?? '');
}
